var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_2230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92771 10.7569L5.07071 10.2429L6.11621 8.49992H3.61621L5.57071 5.24292L6.42771 5.75692L5.38221 7.49992H7.88221L5.92771 10.7569Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999 3.5H14.499V2H13.499V3.5H12.999V6.5H13.499V12.25C13.499 12.4489 13.42 12.6397 13.2794 12.7803C13.1387 12.921 12.9479 13 12.749 13C12.5501 13 12.3593 12.921 12.2187 12.7803C12.078 12.6397 11.999 12.4489 11.999 12.25V8C11.999 7.86739 11.9463 7.74021 11.8526 7.64645C11.7588 7.55268 11.6316 7.5 11.499 7.5H9.49902V2.5C9.49902 2.36739 9.44635 2.24021 9.35258 2.14645C9.25881 2.05268 9.13163 2 8.99902 2H2.49902C2.36642 2 2.23924 2.05268 2.14547 2.14645C2.0517 2.24021 1.99902 2.36739 1.99902 2.5V13H0.999023V14H10.499V13H9.49902V8.5H10.999V12.25C10.999 12.7141 11.1834 13.1592 11.5116 13.4874C11.8398 13.8156 12.2849 14 12.749 14C13.2132 14 13.6583 13.8156 13.9865 13.4874C14.3146 13.1592 14.499 12.7141 14.499 12.25V6.5H14.999V3.5ZM8.49902 13H2.99902V3H8.49902V13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_2230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(-0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.62263a033f66b7e780df334a4a370f64.svg";
export { ForwardRef as ReactComponent };